module.exports = __webpack_public_path__ + "static/media/add_members.98d0d22c.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ftyc/img/add_members.png
 ** module id = 1460
 ** module chunks = 0
 **/